import { ValidCaseState } from '@core/model/domain/caseState';
import { Bad } from '@core/model/framework/Result/BadResult';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { AccountService } from '@core/model/service/accountService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type GetCaseStateInput = {
  userId: string;
  userToken: string;
};

export type GetCaseStateOutput = Promise<OkVal<ValidCaseState> | Bad<'GET_CASE_STATE_FAILED'>>;

@injectable()
export class GetCaseState implements Usecase<GetCaseStateInput, GetCaseStateOutput> {
  constructor(
    @inject(SERVICE_ID.accountService)
    private readonly accountService: AccountService
  ) {}

  async execute(cmd: GetCaseStateInput): GetCaseStateOutput {
    const result = await this.accountService.getCaseState(cmd);

    return result;
  }
}
